import clamp from 'lodash/clamp';
export const calculateFillPct = ({ min, max, value, }) => {
  if (max === 0 || max - min <= 0) {
    return 0;
  }
  const calculated = Math.round(((value - min) / (max - min)) * 1000) / 10;
  return clamp(calculated, 0, 100);
};
